import React, { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { StrictMode } from 'react';
import { HelmetProvider } from 'react-helmet-async';

import App from './App';
import RadioListen from './Pages/RadioLocal/Listen.jsx';
import ScrollToTop from './Helpers/ScrollToTop.jsx';
import VoxWelcomeLoader from './components/Home/VoxWelcomeLoader.jsx';

const Category = lazy(() => import('./Pages/Categories/Category'));
const SearchPage = lazy(() => import('./components/Search/SearchPage'));
const Login = lazy(() => import('./components/Home/Login'));
const Ui = lazy(() => import('./Pages/Admin/Ui'));
const EditPostContainer = lazy(() => import('./components/Admin/EditPostContainer'));
const Post = lazy(() => import('./Pages/Admin/Posts'));
const PostContainer = lazy(() => import('./Pages/PostContainer/PostContainer'));
const RadioAdmin = lazy(() => import('./Pages/RadioLocal/Admin.jsx'));
const ClimaNew = lazy(() => import('./components/Weather/ClimaNew.jsx'));
const Untitulado = lazy(() => import('./components/Home/Carousel/untitulado.jsx'));
const HomeTest = lazy(() => import('./Pages/HomeTest/HomeTest.jsx'));
const RadioPlayer = lazy(() => import('./components/Player/RadioPlayer'));
const NotFoundPage = lazy(() => import('./components/notFoundPage.jsx'));
const RadarPage = lazy(() => import('./Pages/RadarPage.jsx'));

function ProtectedRoute({ children }) {
  try {
    const u = JSON.parse(localStorage.getItem('userInfo') || 'null');
    if (!u?.token && !u?.userData) return <Navigate to='/account/login' replace />;
    return children;
  } catch { return <Navigate to='/account/login' replace />; }
}

function LoadingPremium() {
  return <div style={{minHeight:'100vh', background:'#F5F4F1', display:'grid', placeItems:'center'}}><VoxWelcomeLoader loading={true} /></div>;
}

createRoot(document.getElementById('root')).render(
  <>
    <HelmetProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ScrollToTop />
        <Suspense fallback={<LoadingPremium />}>
          <Routes>
            <Route path='/' element={<HomeTest />} />
            
            {/* Rutas fijas primero */}
            <Route path='/search/:category' element={<Category />} />
            <Route path='/busqueda' element={<SearchPage />} />
            <Route path='/Weather' element={<ClimaNew />} />
            <Route path='/Clima' element={<Untitulado />} />
            <Route path='/Player' element={<RadioPlayer />} />
            <Route path='/RadioAdmin' element={<ProtectedRoute><RadioAdmin /></ProtectedRoute>} />
            <Route path='/RadioListen' element={<RadioListen />} />
            <Route path='/account/login' element={<Login />} />
            <Route path='/admin' element={<ProtectedRoute><Ui /></ProtectedRoute>} />
            <Route path='/admin/edit/:post' element={<ProtectedRoute><EditPostContainer /></ProtectedRoute>} />
            <Route path='/Publicaciones/Nueva/Crear' element={<ProtectedRoute><Post /></ProtectedRoute>} />

            {/* Notas: SOLO con categoria/slug - formato valido */}
            <Route path='/:category/:slug' element={<PostContainer />} />

            {/* TODO lo demás -> 404 REAL */}
            <Route path='/404' element={<NotFoundPage />} />
            <Route path='*' element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  </>
);